import { type ClassValue, clsx } from 'clsx';

// Utility function to combine class names (similar to clsx but handles our design tokens)
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

// Convert design token values to CSS classes
export const getColorClass = (color: string, shade: number = 500, property: 'bg' | 'text' | 'border' = 'bg') => {
  return `${property}-${color}-${shade}`;
};

// Convert spacing tokens to Tailwind classes
export const getSpacingClass = (size: string, property: 'p' | 'm' | 'px' | 'py' | 'mx' | 'my' = 'p') => {
  const spacingMap = {
    xs: '1',
    sm: '2', 
    md: '3',
    lg: '4',
    xl: '6',
    '2xl': '8',
    '3xl': '12',
  };
  return `${property}-${spacingMap[size as keyof typeof spacingMap] || size}`;
};

// Animation utilities
export const animations = {
  fadeIn: 'animate-in fade-in duration-200',
  slideIn: 'animate-in slide-in-from-top-2 duration-200',
  scaleIn: 'animate-in zoom-in-95 duration-200',
};

// Focus ring utility for accessibility - removed ring styling
export const focusRing = 'focus:outline-none';

// Interactive states
export const interactiveStates = {
  hover: 'hover:bg-gray-50 transition-colors duration-150',
  active: 'active:bg-gray-100',
  disabled: 'disabled:opacity-50 disabled:cursor-not-allowed',
};